/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DocumentOcrStatusesViewModel } from "../types/DocumentOcrStatusesViewModel.ts";
import { documentOcrDocumentStatusViewModelSchema } from "./documentOcrDocumentStatusViewModelSchema.ts";

export const documentOcrStatusesViewModelSchema = z.object({
  rg: z.optional(z.lazy(() => documentOcrDocumentStatusViewModelSchema)),
  cpf: z.optional(z.lazy(() => documentOcrDocumentStatusViewModelSchema)),
  diploma: z.optional(z.lazy(() => documentOcrDocumentStatusViewModelSchema)),
}) as unknown as ToZod<DocumentOcrStatusesViewModel>;
